import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';
import { IPriceCycle } from '../interfaces/cart-details.interface';

@Component({
  selector: 'inline-prices-component',
  templateUrl: './inline-prices.component.html',
})
export class InlinePricesComponent {

  @Input() prices: IPriceCycle[];

  @Input() itemIndex: number;

  @Input() automationId: string;

  constructor(
    private commonInfo: CommonInfoService
  ) {
  }

  getPrice(price: any) {
    return price.price[this.commonInfo.taxName];
  }

}

